var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.1875 9.1875C1.95544 9.1875 1.73288 9.27969 1.56878 9.44378C1.40469 9.60788 1.3125 9.83044 1.3125 10.0625C1.3125 10.2946 1.40469 10.5171 1.56878 10.6812C1.73288 10.8453 1.95544 10.9375 2.1875 10.9375C2.41956 10.9375 2.64212 10.8453 2.80622 10.6812C2.97031 10.5171 3.0625 10.2946 3.0625 10.0625C3.0625 9.83044 2.97031 9.60788 2.80622 9.44378C2.64212 9.27969 2.41956 9.1875 2.1875 9.1875ZM4.27383 9.40625H13.3438C13.7074 9.40625 14 9.69883 14 10.0625C14 10.4262 13.7074 10.7188 13.3438 10.7188H4.27383C3.99492 11.6074 3.16641 12.25 2.1875 12.25C0.978906 12.25 0 11.2711 0 10.0625C0 8.85391 0.978906 7.875 2.1875 7.875C3.16641 7.875 3.99492 8.51758 4.27383 9.40625ZM10.9375 3.9375C10.9375 4.16956 11.0297 4.39212 11.1938 4.55622C11.3579 4.72031 11.5804 4.8125 11.8125 4.8125C12.0446 4.8125 12.2671 4.72031 12.4312 4.55622C12.5953 4.39212 12.6875 4.16956 12.6875 3.9375C12.6875 3.70544 12.5953 3.48288 12.4312 3.31878C12.2671 3.15469 12.0446 3.0625 11.8125 3.0625C11.5804 3.0625 11.3579 3.15469 11.1938 3.31878C11.0297 3.48288 10.9375 3.70544 10.9375 3.9375ZM9.72617 3.28125C10.0051 2.39258 10.8336 1.75 11.8125 1.75C13.0211 1.75 14 2.72891 14 3.9375C14 5.14609 13.0211 6.125 11.8125 6.125C10.8336 6.125 10.0051 5.48242 9.72617 4.59375H0.65625C0.292578 4.59375 0 4.30117 0 3.9375C0 3.57383 0.292578 3.28125 0.65625 3.28125H9.72617Z",
    fill: "#4A4F55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.657b16a8d0dd0e33174bb6b54fb6f146.svg";
export { ForwardRef as ReactComponent };